import React, { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

import styles from './ManagedProduct.module.scss';
import { Icon } from 'js/components';
import { faUser, faCircleSmall } from '@fortawesome/pro-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons';
import { useStandardCollator } from 'js/utils/string';
import { format } from 'date-fns';

function UserGroupStatCard({ userGroup }) {
  const { workspaceId } = useParams();

  const collator = useStandardCollator();
  // const { capability_sets = [] } = userGroup;
  const capabilities = useMemo(() => {
    return userGroup.capability_sets
      .flatMap((cs) => cs.capabilities)
      .sort(
        (a, b) =>
          collator.compare(a.name, b.name) || collator.compare(a.id, b.id)
      );
  }, [userGroup, collator]);

  const lastAssessed = useMemo(() => {
    return userGroup.last_assessed_at
      ? format(new Date(userGroup.last_assessed_at), 'MMM d, yyyy')
      : 'Never';
  }, [userGroup]);

  return (
    <Card>
      <CardBody>
        <div className={styles['stat-card-body']}>
          <div className={styles['stat-card-main']}>
            <div className={styles['stat-card-main-header']}>
              <h5>
                <Link to={`/w/${workspaceId}/pm/user-groups/${userGroup.id}`}>
                  {userGroup.name}
                </Link>
              </h5>
              <div className={styles['stat-card-product-managers']}>
                {userGroup.product_managers.map((pm) => {
                  return <span key={pm.id}>{pm.name}</span>;
                })}
              </div>
            </div>
            <div className={styles['stat-card-capabilities']}>
              {capabilities.map((c, i) => {
                return (
                  <React.Fragment key={c.id}>
                    {i > 0 && (
                      <Icon
                        icon={faCircleSmall}
                        className="text-muted icon-left icon-right"
                        transform="shrink-9"
                      />
                    )}
                    <span>{c.name}</span>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
          <div className={styles['stat-card-sidebar']}>
            <div className={styles['stat-card-members']}>
              <Icon icon={faUser} className="text-info icon-left" />
              <span>{userGroup.members.length}</span>
            </div>
            <div className={styles['stat-card-last-assessed']}>
              <label>Last assessed</label>
              <div>
                <Icon icon={faCalendarAlt} className="text-info icon-left" />
                <span>{lastAssessed}</span>
              </div>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default UserGroupStatCard;
